module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_7-8f76e83dd0bd9b35f4d077b652f44dc9.svg";